export function tableWrapperInit({ moveClasses = false } = {}) {
  const content = document.querySelector('.content');
  if (!content) return;

  const tables = content.querySelectorAll('table');

  tables.forEach(table => {
    const parent = table.parentElement;
    if (!parent) return;

    // jeśli już opakowane, pomiń
    if (parent.classList && parent.classList.contains('table-wrapper')) return;

    const wrapper = document.createElement('div');
    wrapper.classList.add('table-wrapper');

    // skopiuj klasy z table do wrappera
    Array.from(table.classList).forEach(cls => {
      if (cls) wrapper.classList.add(cls);
    });

    // jeśli chcesz przenieść (zamiast kopiować), usuń klasy z samej tabeli
    if (moveClasses) {
      Array.from(table.classList).forEach(cls => {
        table.classList.remove(cls);
      });
    }

    // wstaw wrapper i przenieś tabelę do środka
    parent.insertBefore(wrapper, table);
    wrapper.appendChild(table);

    // dodaj styl overflow-x
    wrapper.style.overflowX = 'auto';
  });
}
